export const apiField = 'shortest_row_length';

export const makeConfig = (min: number = 1, max:number = 9999, label: string = 'shortest_row_length') => {
  return {
    type: 'Number',
    apiField: apiField,
    label,
    missing: undefined,
    tooltip: () => 'Shortest Row Length in array',
    min,
    max,
  }
};

const config = makeConfig();

export default config;
